'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

function createPeers(_ref) {
  var network = _ref.network;

  function peers() {
    return _peers.apply(this, arguments);
  }

  function _peers() {
    _peers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var options,
          _yield$network$use,
          libp2p,
          peers,
          _iterator,
          _step,
          _step$value,
          peerId,
          connections,
          _iterator2,
          _step2,
          connection,
          peer,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              _context.next = 3;
              return network.use(options);

            case 3:
              _yield$network$use = _context.sent;
              libp2p = _yield$network$use.libp2p;
              peers = [];
              _iterator = _createForOfIteratorHelper(libp2p.connections);

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  _step$value = _slicedToArray(_step.value, 2), peerId = _step$value[0], connections = _step$value[1];
                  _iterator2 = _createForOfIteratorHelper(connections);

                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      connection = _step2.value;
                      peer = {
                        addr: connection.remoteAddr,
                        peer: peerId
                      };

                      if (options.verbose || options.direction) {
                        peer.direction = connection.stat.direction;
                      }

                      if (options.verbose) {
                        peer.muxer = connection.stat.multiplexer;
                        peer.latency = 'n/a';
                        peer.streams = [];
                      }

                      peers.push(peer);
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              return _context.abrupt("return", peers);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _peers.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(peers);
}

exports.createPeers = createPeers;